import { PlayerRoleEnum } from '../types/graphql-generated';

export const PLAYER_ROLE_BAR_COLORS: Record<PlayerRoleEnum, string> = {
  [PlayerRoleEnum.Portero]: '#e8792b',
  [PlayerRoleEnum.Defensa]: '#7b3fe4',
  [PlayerRoleEnum.Centrocampista]: '#2f6bd8',
  [PlayerRoleEnum.Delantero]: '#efb32a',
};

export const DEFAULT_PLAYER_ROLE_BAR_COLOR = '#9aa3b2';

export const getPlayerRoleBarColor = (role: string): string =>
  PLAYER_ROLE_BAR_COLORS[role as PlayerRoleEnum] ?? DEFAULT_PLAYER_ROLE_BAR_COLOR;
